import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Observable } from 'rxjs';
import { Campaign } from 'src/app/models/campaign';
import { Insight } from 'src/app/models/insight';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { AmplifyApiService } from './amplify-api.service';

@Injectable({ providedIn: 'root' })
export class BatchJobService {
  public campaign_jobs_api = APIS.CAMPAIGN_JOBS;
  public insight_jobs_api = APIS.INSIGHTS_JOBS;
  public single_jobs_api = APIS.SINGLE_JOBS;

  protected constructor(
    private toastr: NbToastrService,
    private apiService: AmplifyApiService
  ) {}

  public runCampaign(campaign: Campaign) {
    return new Observable<any>((observer) => {
      this.apiService
        .post(this.campaign_jobs_api, `/${ENVIRONMENT.name}/jobs/campaigns/` + campaign.id, {})
        .then((response) => {
          this.toastr.success('', $localize`Starting Campaign Complete`);
          observer.next(response);
          observer.complete();
        })
        .catch((error) => {
          this.toastr.danger('', $localize`Starting Campaign Failed: ${error}`);
          console.error(error);
        });
    });
  }

  public runInsight(insight: Insight) {
    return new Observable<any>((observer) => {
      this.apiService
        .post(this.insight_jobs_api, `/${ENVIRONMENT.name}/jobs/insights/` + insight.id, {})
        .then((response) => {
          this.toastr.success('', $localize`Starting Insight Complete`);
          observer.next(response);
          observer.complete();
        })
        .catch((error) => {
          this.toastr.danger('', $localize`Starting Insight Failed: ${error}`);
          console.error(error);
        });
    });
  }

  public terminateJob(job_id: string, reason: string) {
    return new Observable<any>((observer) => {
      this.apiService
        .delete(this.single_jobs_api, `/${ENVIRONMENT.name}/jobs/` + job_id, {
          body: { reason }
        })
        .then((response) => {
          this.toastr.success('', $localize`Stopping Batch Job Complete`);
          observer.next(response);
          observer.complete();
        })
        .catch((error) => {
          this.toastr.danger('', $localize`Stopping Batch Job Failed: ${error}`);
          console.error(error);
        });
    });
  }
}
